import Backend from 'i18next-xhr-backend';
import i18n from 'i18next';
import { i18nConfig } from '@mdc/constants';
import lngDetector from '../language-detector/LanguageDetectorService';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(lngDetector);

i18n.use(Backend)
    .use(initReactI18next)
    .use(languageDetector)
    .init(i18nConfig);


function getLocalisedOpswatLink(link) {
    if (i18n.language === 'ja-JP') {
        return link.replace('opswat.com', 'opswat.jp');
    }
    if (i18n.language === 'en-US') {
        return link.replace('opswat.jp', 'opswat.com');
    }
    return link;
}

function i18nT(key) {
    return i18n.getFixedT(i18n.language)(key);
}

export {
    i18n,
    i18nT,
    getLocalisedOpswatLink
};
